module.exports = __webpack_public_path__ + "static/media/uoa-24.4ea2a7de.jpg";